import axios from 'axios';
import { getMethod, postMethod } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const REGISTER_START_REQUEST = 'REGISTER_START_REQUEST';
export const REGISTER_START_SUCCESS = 'REGISTER_START_SUCCESS';
export const REGISTER_START_FAILURE = 'REGISTER_START_FAILURE';

// Action Creators
export const registerStartRequest = () => ({
  type: REGISTER_START_REQUEST,
});

export const registerStartSuccess = (users) => ({
  type: REGISTER_START_SUCCESS,
  payload: users,
});

export const registerStartFailure = (error) => ({
  type: REGISTER_START_FAILURE,
  payload: error,
});

// Thunk Function

export const registerStartPost = (body, external) => {
  return async (dispatch) => {
    dispatch(registerStartRequest());
    try {
      const response = await postMethod(url.postRegisterStart, body);
      if (external?.run === true) {
        if (
          response?.data?.status_code === 200 ||
          response?.data?.status_code === 201
        ) {
          external?.handleFunction(response?.data);
          dispatch(registerStartSuccess(response));
        } else {
          if (external?.error === true) {
            external?.handleFailerFunction(response?.data);
          }
          dispatch(registerStartFailure('error'));
        }
      }
    } catch (error) {
      dispatch(registerStartFailure(error));
    }
  };
};
